/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: true,
  BASE_API_URL: '/apptui_ugm/',

  PAGES: {
    horario: { url: 'horario' },
  },
};
